export default {
    nodes: [],
    inputs: {}
}